<ion-content
  scrollbar
  class="parking-report__container ion-content-padding-top-0"
>
  <ion-grid>
    <app-list-header *ngIf="!this.showLoader"
      (toggleFilter)="onToggleFilter()"
      [absoluteFilterButton]="true"
    >
      <ng-container top>
        <div class="chart">
          <apx-chart
            [series]="parkingReportServ.chartOptions.series"
            [chart]="parkingReportServ.chartOptions.chart"
            [xaxis]="parkingReportServ.chartOptions.xaxis"
            [stroke]="parkingReportServ.chartOptions.stroke"
            [dataLabels]="parkingReportServ.chartOptions.dataLabels"
            [markers]="parkingReportServ.chartOptions.markers"
            [colors]="parkingReportServ.chartOptions.colors"
            [grid]="parkingReportServ.chartOptions.grid"
            [yaxis]="parkingReportServ.chartOptions.yaxis"
            [title]="parkingReportServ.chartOptions.title"
            [noData]="parkingReportServ.chartOptions.noData"
          ></apx-chart>
        </div>
        <hr class="margin-divider" *ngIf="p.renderMobile" />
      </ng-container>

      <ng-container bottom *ngIf="!p.renderMobile">
        <div class="parking-report__btns">
          <div class="display-flex ion-align-items-center">
            <app-select-dropdown
              class="space-filter__dropdown"
              [data]="buildingServ.buildings"
              [value]="parkingReportServ.request.building"
              (changeValueEvent)="onFilterBuilding($event)"
              placeholder="ADMIN.PARKING.BUILDING"
            ></app-select-dropdown>
  
            <app-select-dropdown
              *appHasRole="['company.view']"
              class="space-filter__dropdown"
              [data]="companyServ.companies"
              [value]="parkingReportServ.request.company"
              (changeValueEvent)="onFilterCompany($event)"
              placeholder="ADMIN.PARKING.COMPANY"
            ></app-select-dropdown>
  
            <span class="margin-right-8">
              {{ "ADMIN.PARKING.DATE_FROM" | translate }}:
            </span>
            <app-date-time-picker
              pickerType="calendar"
              placeholder="{{ 'ADMIN.PARKING.SELECT_DAY' | translate }}"
              (afterPickerClosed)="onFilterDate($event, 'start')"
              [value]="parkingReportServ.request.dateFrom"
            ></app-date-time-picker>
  
            <span class="margin-left-8 margin-right-8">
              {{ "ADMIN.PARKING.DATE_TO" | translate }}:
            </span>
            <app-date-time-picker
              pickerType="calendar"
              placeholder="{{ 'ADMIN.PARKING.SELECT_DAY' | translate }}"
              (afterPickerClosed)="onFilterDate($event, 'end')"
              [value]="parkingReportServ.request.dateTo"
            ></app-date-time-picker>
  
          </div>
          <div class="display-flex ion-align-items-end">
            <ion-button 
              size="small" 
              fill="outline"
              (click)="exportToCSV()"
            >
              <ion-icon slot="start" name="download-outline"></ion-icon>
              Eksport do CSV
            </ion-button>
          </div>
        </div>
        
      </ng-container>

    </app-list-header>

    <app-pagination-client-side
      [ngClass]="{ 'height-0': showLoader }"
      [componentRef]="componentRef"
      [columns]="columns"
      [options]="options"      
      (rowsLoaderReady)="rowsLoaderServiceReady($event)"
      (refreshRequest)="getParkingBookings()"
    ></app-pagination-client-side>

  </ion-grid>

</ion-content>